import { Group } from 'src/design/atoms/Group';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SubmittalDto } from 'src/api/FiretrolApiClient';
import { useAuth } from 'src/hooks/useAuth';
import { useJobs } from 'src/hooks/useJobs';
import { SecondaryButton } from 'src/design/atoms/SecondaryButton';
import { Header } from 'src/design/organisms/Header';
import { jobBreadcrumbs } from 'src/app/workflows/jobBreadcrumbs';
import { SubmittalForm } from 'src/routes/Jobs/Submittals/components/SubmittalForm';

const emptySubmittal: Partial<SubmittalDto> = {
  title: '',
  type: 'type_1',
  intentOfReview: 'review',
  assignee: undefined,
  company: '',
  submittalNumber: '',
  externalSubmittalNumber: '',
  status: '',
  workflow: undefined,
  assigneeUserId: undefined,
  attachments: [],
  revisions: [],
  stepIndex: -1,
  job: undefined,
  id: '',
  createdAt: undefined,
  reporter: undefined,
  submittedOn: undefined,
  updatedAt: undefined,
  history: [],
  milestonePhaseItemId: undefined,
  submittedToContactId: undefined,
  submittedToContact: undefined,
};

export const SubmitSubmittal: React.FC = () => {
  const { selectedJob } = useJobs();
  const { user } = useAuth();
  const navigate = useNavigate();
  const initialValues: SubmittalDto = React.useMemo(() => {
    return {
      ...emptySubmittal,
      id: '',
      submittalId: 0,
      jobId: selectedJob?.id,
      workflowId: selectedJob?.submittalWorkflowId ?? undefined,
      workflow: selectedJob?.submittalWorkflow ?? undefined,
      reporterUserId: user?.id,
    } as SubmittalDto;
  }, [selectedJob?.submittalWorkflow, user?.id]);
  if (!selectedJob) return null;
  return (
    <>
      <Header
        breadcrumbProps={{
          items: jobBreadcrumbs(
            selectedJob,
            { text: 'Submittals', href: `/jobs/${selectedJob.id}/submittals` },
            'Create Submittal',
          ),
        }}
        title="Create Submittal"
        helpText="Create a new submittal for this job."
      />
      <Group justify="flex-end" mb="md">
        <SecondaryButton
          onClick={() => navigate(`/jobs/${selectedJob.id}/submittals`)}
        >
          Cancel
        </SecondaryButton>
      </Group>
      <SubmittalForm
        initialValues={initialValues}
        selectedJob={selectedJob}
        onSaved={(submittal) =>
          navigate(`/jobs/${selectedJob.id}/submittals/${submittal.id}`)
        }
        onCreated={(submittal) =>
          navigate(`/jobs/${selectedJob.id}/submittals/${submittal.id}`)
        }
      />
    </>
  );
};
